let getRegExp = function (locale) {
    switch (locale) {
        default:
            return /^(?:\+7|\b7)\s*\((9|8|4)\d{2}\)\s*\d{3}-\d{2}-\d{2}$/;
        case 'KZ':
            return /^\+\d{1,2}\s+?\(\d{3,5}\)\s+?\d{1,3}-\d{2}-\d{2}$/;
        case 'AM':
            return /^\+374\s+?\(\d{2}\)\s+?\d{2}-\d{2}-\d{2}$/;
        case 'BY':
            return /^\+375\s+?\(\d{2}\)\s+?\d{3}-\d{2}-\d{2}$/;
        case 'KG':
            return /^\+996\s+?\(\d{3}\)\s+?\d{2}-\d{2}-\d{2}$/;
    }
};

let getMask = function (locale) {
    switch (locale) {
        default:
            return '+7 (999) 999-99-99';
        case 'KZ':
            return '+7 (999) 999-99-99';
        case 'AM':
            return '+374 (99) 99-99-99';
        case 'BY':
            return '+375 (99) 999-99-99';
        case 'KG':
            return '+\\9\\96 (999) 99-99-99';
    }
};

let getNumberLength = function (locale) {
    switch (locale) {
        default:
            return 10;
        case 'KZ':
            return 10;
        case 'AM':
            return 8;
        case 'BY':
            return 9;
        case 'KG':
            return 9;
    }
};

let getCode = function (locale) {
    switch (locale) {
        default:
            return '+7';
        case 'KZ':
            return '+7';
        case 'AM':
            return '+374';
        case 'BY':
            return '+375';
        case 'KG':
            return '+996';
    }
};

let getPlaceholder = function (locale) {
    switch (locale) {
        default:
            return '+7 (912) 123-45-67';
        case 'KZ':
            return '+7 (700) 123-45-67';
        case 'AM':
            return '+374 (99) 99-99-99';
        case 'BY':
            return '+375 (99) 999-99-99';
        case 'KG':
            return '+996 (999) 99-99-99';
    }
};

let getLocaleSetings = function (locale) {
    return {
        phoneRegExp: getRegExp(locale),
        phoneMask: getMask(locale),
        numberLength: getNumberLength(locale),
        code: getCode(locale),
        placeholder: getPlaceholder(locale),
    };
};

export { getLocaleSetings };
